import React from 'react';
import type {MapRef} from 'react-map-gl/mapbox';

/*
mapbox-gl 3.3's trackResize follows window resizes only, not container resizes,
so a layout-driven size change (an expand toggle, new dims) needs an explicit
resize once the new layout has been applied — hence the rAF.
*/
export function useResizeMapOnChange(
  mapRef: React.RefObject<MapRef>,
  deps: React.DependencyList
): void {
  React.useEffect(() => {
    const raf = requestAnimationFrame(() => mapRef.current?.resize());
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
